<template>
  <div class="row one-tariff mb-2" v-on:click="selectTariff()">
    <div class="col-8 align-self-center pl-1">
      <div class="row period">
        {{ period }} {{ declOfNum(period, ['МЕСЯЦ', 'МЕСЯЦА', 'МЕСЯЦЕВ']) }}
      </div>
      <div class="row currency" v-if="period>1">
        {{ price }} руб. за {{ period }} {{ declOfNum(period, ['МЕСЯЦ', 'МЕСЯЦА', 'МЕСЯЦЕВ']) }}
      </div>
      <div class="row discount d-inline-block" v-if="period>1">
        Экономия
      </div>
    </div>
    <div class="col-4 price  align-self-center">
      <div class="row  justify-content-end">
        {{ Math.round(price / period).toFixed(2) }}
      </div>
      <div class="row currency justify-content-end mr-1">
        руб./мес
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'OneTariff',
  props: ['price', 'period', 'tariffId', 'payOrder', 'showMethods'],
  data () {
    return {}
  },
  methods: {
    selectTariff: function () {
      this.showMethods(this.tariffId)
    },
    declOfNum: function (number, titles) {
      const cases = [2, 0, 1, 1, 1, 2]
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.one-tariff {
  cursor: pointer;
  color: #525960;
  height: 85px;
  background: white;
  border-radius: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

@media (max-width: 767px) {
  .one-tariff {
    width: 330px;
    height: 105px;
  }

  .one-tariff .price {
    font-size: 24px;
    line-height: 22px
  }
}

@media (min-width: 767px) {
  .one-tariff {
    width: 365px;
  }

  .one-tariff .price {
    font-size: 32px;
    line-height: 22px
  }

}

.one-tariff .period {
  color: #FF7684;
}

.one-tariff .discount {
  font-size: 14px;
  background: #27A9CA;
  border-radius: 15px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}

.one-tariff .price .currency {
  font-size: 14px;
}
</style>
